<div class="dataLoading" *ngIf="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<div *ngIf="!dataLoading">
  <div class="empty-data-add" *ngIf="!plansData.pageData.length">
    <p>{{ 'case.No treatment plan yet—waiting for yours!' | translate }}</p>
    <div *ngIf="plansData.canAdd">
      <button class="btn btn-blue" (click)="openForm()">
        {{'case.Add Treatment Plan' | translate}}
      </button>
    </div>
  </div>


  <ng-container *ngIf="plansData.pageData.length">
    <div class="crud-list-wrapper">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="main-title">{{ 'case.Treatment Plan' | translate }}</h4>
        <button *ngIf="plansData.canAdd" class="btn btn-blue py-0 px-2 m-0"
          (click)="openForm()">+</button>
      </div>

      <div class="crud-list-container">
        <div class="crud-list">
          <div cdkDropList (cdkDropListDropped)="drop($event)">
            <div *ngFor="let item of plansData.pageData; index as i;" class="crud-control" cdkDrag>
              <span class="drag-me" cdkDragHandle>
                <img src="./assets/images/icons/drag-drop-icon.svg" alt="">
              </span>
              <span class="item-icon" *ngIf="item.medicalPhase.icon">
                <!-- <img [src]="item.icon" alt=""> -->
                  <svg width="20" height="20" viewBox="0 0 20 20" [innerHTML]="item.medicalPhase.icon | sanitizeHtml"></svg>
              </span>
              <div>
                <div class="form-control">
                  <span class="fontSemiBold">{{item.medicalPhase.name}}</span>:
                  {{item.medicalPhasefields[0].fieldname}}
                </div>
              </div>
              <div class="actions">
                <button class="btn" *ngIf="item.canDelete" (click)="deleteRecord(item.id)">
                  <img alt="" src="./assets/images/icons/delete-icon.svg">
                </button>
                <button class="btn" *ngIf="item.canEdit" (click)="openForm(item)">
                  <img alt="" src="./assets/images/icons/edit-icon.svg">
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

    <app-case-voting [agendaItem]="item" [module]="VotingView.Plan"></app-case-voting>
  </ng-container>

</div>
